import client from 'FrontendJsAssets/common/client'

const rDpdParcelshop = {
    config: null,
    loadWidgetScript() {
        if (typeof DpdPudo !== 'undefined') {
            return Promise.resolve()
        }

        return new Promise((resolve, reject) => {
            const script = document.createElement('script')

            const holderEl = document.querySelector('[r-dpd-parcelshop-holder]')
            const allowedTypes = holderEl.getAttribute('data-allowed-types')

            script.src = 'https://pus-maps.dpd.sk/lib/library.js'
            script.type = 'text/javascript'
            script.onload = () => {
                this.widgetInstance = new DpdPudo.Widget({
                    ...this.config,
                    allowedPudoTypes: JSON.parse(allowedTypes)
                })

                resolve()
            }
            script.onerror = reject

            document.head.appendChild(script)
        });
    },
    async openModal() {
        for (const trigger of document.querySelectorAll('[r-dpd-parcelshop-trigger]')) {
            trigger.classList.add('is-loading')
        }

        await this.loadWidgetScript()

        this.widgetInstance
            .open()
            .then((data) => {
                this.processSelectedBranch(data)
            })
            .catch((code, a,b,c,d,e,f) => {
                if (['closed', 'closed_by_user'].includes(code)) {
                    return
                }

                let errorMessage = ''
                if (code === 'missing_api_key' || code === 'invalid_api_key') {
                    errorMessage = 'Invalid or missing API key'
                } else if (code === 'widget_already_active') {
                    errorMessage = 'Widget is already active'
                } else if (code === 'container_element_is_null') {
                    errorMessage = 'Container element is null'
                } else if (code === 'wrong_data') {
                    errorMessage = 'Wrong data'
                } else {
                    errorMessage = 'Unknown error'
                }

                Eshop.alert(errorMessage, {
                    type: 'error'
                });
            });

        for (const trigger of document.querySelectorAll('[r-dpd-parcelshop-trigger]')) {
            trigger.classList.remove('is-loading')
        }
    },
    processSelectedBranch(data) {
        if (!data) {
            return
        }

        document.querySelector('[r-dpd-parcelshop-holder]').classList.add('is-loading')
        document.querySelector('[r-dpd-parcelshop-empty]').classList.remove('hidden')
        document.querySelector('[r-dpd-parcelshop-selected]').classList.add('hidden')
        document.querySelector('input[name="shipping_module_id"][r-dpd-parcelshop-input]').value = null

        client.post('/create-dpd-parcelshop-branch', data)
            .then((response) => {
                const responseData = response.data

                if (!responseData.status) {
                    this.failedCallback()

                    return false
                }

                data.id = responseData.data.id

                this.successCallback(data)
            })
            .catch((error) => {
                console.error(error)

                this.failedCallback()
            })
    },
    failedCallback() {
        document.querySelector('input[name="shipping_module_id"][r-dpd-parcelshop-input]').value = null
        document.querySelector('[r-dpd-parcelshop-holder]').classList.remove('is-loading')
    },
    successCallback(data) {
        document.querySelector('input[name="shipping_module_id"][r-dpd-parcelshop-input]').value = data.id
        document.querySelector('input[name="shipping_name"]').value = data.name
        document.querySelector('input[name="shipping_address"]').value = data.street
        document.querySelector('input[name="shipping_post_code"]').value = data.zip
        document.querySelector('input[name="shipping_city"]').value = data.city

        document.querySelector('[r-dpd-parcelshop-selected]').classList.remove('hidden')
        document.querySelector('[r-dpd-parcelshop-selected-branch]').innerText = data.name
        document.querySelector('[r-dpd-parcelshop-selected-address]').innerText = data.addressText
        document.querySelector('[r-dpd-parcelshop-empty]').classList.add('hidden')
        document.querySelector('[r-dpd-parcelshop-holder]').classList.remove('is-loading')

        document.getElementById('error-branch').style.display = 'none'
    },
    init(config) {
        if (!config.apiKey) {
            console.error('apiKey is not defined')

            return
        }

        this.config = config

        setTimeout(() => {
            for (const shippingInput of document.querySelectorAll('input[name="shipping_id"]')) {
                shippingInput.addEventListener('change', (event) => {
                    if (
                        event.target.closest('.shopping-modules__item').querySelector('[r-dpd-parcelshop-trigger]') &&
                        !document.querySelector('[r-dpd-parcelshop-empty]').classList.contains('hidden')
                    ) {
                        this.openModal()
                    }
                })
            }
        }, 100)

        for (const trigger of document.querySelectorAll('[r-dpd-parcelshop-trigger]')) {
            trigger.addEventListener('click', (event) => {
                this.openModal()
            })
        }
    }
}

const configPerHostname = {
    // production
    'www.rajhraciek.sk': {
        apiKey: 'tgnrfpdqjv9qpo97l0dqp5zo6ozldr7a',
        allowedCountries: ['sk'],
    },
    'www.rajhracky.cz': {
        apiKey: '81l7n1vq6ppncg3x7r4dhfntmboso2lr',
        allowedCountries: ['cz'],
    },
    'www.jatekraj.hu': {
        apiKey: '2ltj6tcovu9qczeinnvm2fc2dxo5mgwq',
        allowedCountries: ['hu'],
    },
    'www.rajspielzeug.at': {
        apiKey: '0qbvcvgqanbj2iygh3g0oeljtd2qelrh',
        allowedCountries: ['at'],
    },
    'www.raiigrachky.bg': {
        apiKey: 'po2daqr0leqixzwdzazka2bxaix23h85',
        allowedCountries: ['bg'],
    },
    'www.raijucarii.ro': {
        apiKey: 'sdqrsymp89x17uu3h8atxvd293z5lrvm',
        allowedCountries: ['ro'],
    },
    'www.rajzaigrace.si': {
        apiKey: 'nteasg267pmy6boep5orm83me7npaqn9',
        allowedCountries: ['si'],
    },
    'www.rajzaigracke.hr': {
        apiKey: 'xzmieri20hkqd3k1eqck9t6ynp4eyb8t',
        allowedCountries: ['hr'],
    },
    'www.rajgiocattoli.it': {
        apiKey: 'blc1etjuxu4vjs6lqjq8f8xgnakw43vr',
        allowedCountries: ['it'],
    },
    'www.rajdujouet.fr': {
        apiKey: 'htz2p0v0y3wy6romntux9ducl112im2s',
        allowedCountries: ['fr'],
    },
    'www.raijuguetes.es': {
        apiKey: 'hra1dvzk6acjqfk9425q0v08804qmwar',
        allowedCountries: ['es'],
    },

    // test
    'rajhraciek.rshop.sk': {
        apiKey: 'ujgz4ohnqyc6mfyqm1sycnovi091gu95',
        allowedCountries: ['sk'],
    },
    'rajhracky.rshop.sk': {
        apiKey: '1h7ngytbf21faa8va98iyy8plvkyn3zp',
        allowedCountries: ['cz'],
    },
    'jatekraj.rshop.sk': {
        apiKey: '46o0jbwvz1lr2uxaisdu1aekgag4gco0',
        allowedCountries: ['hu']
    },
    'rajspielzeug-at.rshop.sk': {
        apiKey: '4vv6ddaiwo97bzlv4zdm2li76je7tnrk',
        allowedCountries: ['at']
    },
    'www.raiigrachky.rshop.sk': {
        apiKey: 'lwola7jjoukdy58ath4tp26xc5x2ydg4',
        allowedCountries: ['bg'],
    },
    'www.raijucarii.rshop.sk': {
        apiKey: 'ihng6822oav176gsrxk5nxur4sk11gna',
        allowedCountries: ['ro'],
    },
    'www.rajzaigrace.rshop.sk': {
        apiKey: 'dlp5slt2lb1q72utcxb9f79durnjfens',
        allowedCountries: ['si'],
    },
    'www.rajzaigracke.rshop.sk': {
        apiKey: 'uzolpq45y99q177vg39qugxp0mfle33f',
        allowedCountries: ['hr'],
    },
    'www.rajgiocattoli.rshop.sk': {
        apiKey: 'ndf5hwbsu533bl43qm1xuewzwo95oepq',
        allowedCountries: ['it'],
    },
    'www.rajdujouet.rshop.sk': {
        apiKey: 'd9f2l3fmwvcxciu1t5jkl62k3fa54gw2',
        allowedCountries: ['fr'],
    },
    'www.raijuguetes.rshop.sk': {
        apiKey: 'x8i1inwag5poit8gsxql3c93voe7aucs',
        allowedCountries: ['es'],
    },


    // lokal
    'dev.rajhraciek.test': {
        apiKey: 't26mv1b0yul0yo1v6gj28bg64s1vezgv',
        allowedCountries: ['sk'],
    },
}

const currentHostname = window.location.hostname

let currentHostnameConfig = null
if (configPerHostname[currentHostname]) {
    currentHostnameConfig = configPerHostname[currentHostname]
}

if (currentHostnameConfig) {
    rDpdParcelshop.init(currentHostnameConfig)
} else {
    console.warn(`DPD Parcelshop does not have config for current hostname: "${currentHostname}", therefore it will not be initialized`)
}
